export type JobAlertFrequency = "DAILY" | "WEEKLY" | "MONTHLY";

export type OpenToWorkStatus = "ACTIVE" | "PASSIVE" | "NOT_LOOKING";

export interface CandidateSettings {
  userId: string;

  // Job alert notifications
  jobAlertEnabled: boolean;
  jobAlertFrequency: JobAlertFrequency;
  emailJobAlerts: boolean;
  emailWeeklyDigest: boolean;
  emailRecruiterOutreach: boolean;
  emailApplicationUpdates: boolean;
  emailProductUpdates: boolean;

  // Profile visibility
  profileVisibleToRecruiters: boolean;
  showInLeadershipNetwork: boolean;
  showLinkedin: boolean;
  allowDirectMessages: boolean;
  searchableByRecruiters: boolean;

  // Open to work
  openToWorkStatus: OpenToWorkStatus;
  targetRoles: string | null;
  noticePeriodDays: number;
  openToWorkVisible: boolean;

  createdAt?: string;
  updatedAt?: string;
}

export type CandidateSettingsUpdate = Partial<Omit<CandidateSettings, "userId" | "createdAt" | "updatedAt">>;

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export interface ChangePasswordResponse {
  passwordChanged: boolean;
  otherSessionsRevoked: number;
}

export const JOB_ALERT_FREQUENCY_OPTIONS: { value: JobAlertFrequency; label: string }[] = [
  { value: "DAILY", label: "Daily" },
  { value: "WEEKLY", label: "Weekly" },
  { value: "MONTHLY", label: "Monthly" },
];

export const OPEN_TO_WORK_OPTIONS: { value: OpenToWorkStatus; label: string; hint: string }[] = [
  {
    value: "ACTIVE",
    label: "Actively looking",
    hint: "Recruiters are actively encouraged to reach out.",
  },
  {
    value: "PASSIVE",
    label: "Open, but not actively",
    hint: "You will be contacted about standout roles only.",
  },
  {
    value: "NOT_LOOKING",
    label: "Not looking right now",
    hint: "Your profile stays visible but outreach is paused.",
  },
];
